import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'NoticeInput',
  data () {
    return {
      processing: false,
      
      // flag
      isClickedConfirm: false,

      // 製造番号
      // inpDeviceSerial: null,

      // ロケーションのニックネーム
      locationNickname: null,

      // プライベートお知らせ
      isPrivateNotice: null
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.notice.categoryName,

      // form
      userIdentity: state => state.noticeForm.targetId,
      values: state => state.noticeForm.values,

      // model
      serviceModel: state => state.noticeForm.serviceModel,
      deliveryTypeMstModel: state => state.noticeForm.deliveryTypeMstModel,
      relationalNoticeTypeModel: state => state.noticeForm.relationalNoticeTypeModel,
      serviceAttributeModel: state => state.noticeForm.serviceAttributeModel,
    }),
    ...mapGetters({
      isAdmin: 'auth/isAdmin',
      isOperator: 'auth/isOperator',
      // userServiceUuid: 'auth/userServiceUuid',
      permittedView: 'permission/permittedView',
      isRegister: 'noticeForm/isRegister',
      isModify: 'noticeForm/isModify',
      noticeType: 'noticeForm/noticeType',
    }),

    // result
    resultLocation () {
      return this.locationNickname || '未選択'
    },

    // list
    serviceList () {
      let list = []
      this.serviceModel
        .filter(item => item.serviceStatus === 1)
        .forEach(item => list.push({
        value: item.serviceUuid,
        label: item.serviceName
      }))
      return list
    },
    deliveryTypeList () {
      let list = []
      this.deliveryTypeMstModel
        .filter(item => item.deliveryConfigFlg === 1)
        .forEach(item => list.push({
          value: item.deliveryTypeMstUuid,
          label: item.deliveryTypeName,
          deliveryType: item.deliveryType
        }))
      return list
    },
    noticeTypeList () {
      try {
        return this.relationalNoticeTypeModel
          .filter(item => item.deliveryTypeMstUuid === this.inpDeliveryType)[0].noticeTypeInfo
          .map(item => {
            return {
              value: item.noticeTypeMstUuid,
              label: item.noticeTypeName
            }
          })
      // eslint-disable-next-line
      } catch (e) {
        return []
      }
    },
    targetList () {
      return Constants.ContentsApply.DeliveryToKbn
      // return [
      //   {value: 1, label: '全配信', icon: 'globe'},
      //   {value: 2, label: '地区 : A地区', icon: 'user-tag'}
      // ]
    },
    attributeList () {
      let list = []
      this.serviceAttributeModel
        .filter(item => item.deliveryFlg)
        .forEach(type => {
          type.attributeGroups
            .forEach(group => {
              console.log('@@@', group)
              if (group.attributeGroupCode) {
                const label = type.attributeTypeName + ' : ' + group.attributeGroupName
                list.push({
                  value: group.attributeGroupUuid,
                  label: label
                })
              }
            })
        })
      return list
    },
    locationList () {

    },

    // input
    inpService: {
      get () {
        return this.values.inpService
      },
      set (value) {
        this.setInputValue({
          key: 'inpService',
          value: value
        })
      }
    },
    inpDeliveryType: {
      get () {
        return this.values.inpDeliveryType
      },
      set (value) {
        this.setInputValue({
          key: 'inpDeliveryType',
          value: value
        })
      }
    },
    inpNoticeType: {
      get () {
        return this.values.inpNoticeType
      },
      set (value) {
        this.setInputValue({
          key: 'inpNoticeType',
          value: value
        })
      }
    },
    inpTarget: {
      get () {
        return this.values.inpTarget
      },
      set (value) {
        this.setInputValue({
          key: 'inpTarget',
          value: value
        })
      }
    },
    inpAttribute: {
      get () {
        return this.values.inpAttribute
      },
      set (value) {
        this.setInputValue({
          key: 'inpAttribute',
          value: value
        })
      }
    },
    inpLocation: {
      get () {
        return this.values.inpLocation
      },
      set (value) {
        this.setInputValue({
          key: 'inpLocation',
          value: value
        })
      }
    },
    inpDeviceSerial: {
      get () {
        return this.values.inpDeviceSerial
      },
      set (value) {
        this.setInputValue({
          key: 'inpDeviceSerial',
          value: value
        })
      }
    },

    // enable
    disableDeliveryType () {
      console.log(this.inpServiceIsValid)
      return !this.inpServiceIsValid
    },
    disableNoticeType () {
      return !this.inpDeliveryTypeIsValid
    },
    disableTarget () {
        if (this.isPrivateNotice)
            return true
        else
            return !this.inpServiceIsValid
    },
    disableSearchButton () {
      return this.inpDeviceSerial === null ||
        this.inpDeviceSerial === ''
    },

    // validate
    inpServiceIsValid () {
      return Validator.validSelect(this.inpService)
    },
    inpDeliveryTypeIsValid () {
        const validSelect = Validator.validSelect(this.inpDeliveryType);
        if (validSelect) {
            let deliveryTypeName = ''
            let deliveryType = ''
            this.deliveryTypeList.forEach(value => {
                if (value.value === this.inpDeliveryType){
                  deliveryTypeName = value.label
                  deliveryType = value.deliveryType
                }


            })
            if (deliveryType === Constants.Mst.DeliveryType[0].private_notice) {
                this.isPrivateNotice = true
                this.inpTarget = 2
            } else {
                this.isPrivateNotice = false
                this.inpTarget = ''
            }
        }
        return validSelect
    },
    inpNoticeTypeIsValid () {
      return Validator.validSelect(this.inpNoticeType)
    },
    inpTargetIsValid () {
      return Validator.validSelect(this.inpTarget)
    },
    inpAttributeIsValid () {
      return Validator.validArray(this.inpAttribute)
    },
    inpLocationIsValid () {
      return Validator.validText(this.inpLocation)
    },
    formIsValid () {
      const f1 = this.inpServiceIsValid &&
        this.inpDeliveryTypeIsValid &&
        this.inpNoticeTypeIsValid &&
        this.inpTargetIsValid
      if (this.inpTarget === 1) {
        return f1 && this.inpAttributeIsValid
      } else if (this.inpTarget === 2) {
        return f1 && this.inpLocationIsValid
      } else {
        return f1
      }
    },
    disableConfirmButton () {
      return !this.formIsValid
    }
  },
  watch: {
    inpService: function (to) {
      this.inpTarget = ''
      this.inpDeliveryType = ''
      this.inpNoticeType = ''

      if (to) {
        this.loadAttributes()
      }
    },
    inpDeliveryType: function (to) {
      this.inpNoticeType = ''

      // 配信タイプに紐づくお知らせタイプ一覧を設定
      console.log('pushType', to)

      // this.relationalNoticeTypeModel.filter(item => item.deliveryTypeMstUuid === to)[0].noticeTypeInfo
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      loadServiceDeliveryTypeModel: 'noticeForm/loadServiceDeliveryTypeModel',
    }),
    ...mapMutations({
      setValues: 'noticeForm/setValues',
      setInputValue: 'noticeForm/setInputValue',
      setLocationNickname: 'noticeForm/setLocationNickname'
    }),

    init () {
      if (this.isOperator) {
        this.loadAttributes()
      }
    },

    loadAttributes() {
      // サービスに紐づく配信タイプを取得
      const serviceDeliveryTypeParams = {
        serviceUuid: this.inpService
      }
      const deliveryTypeMstParams = {}
      const serviceAttributeParams = {
        serviceUuid: this.inpService
      }

      // データ読出し
      this.loadServiceDeliveryTypeModel({
        serviceDeliveryTypeParams: serviceDeliveryTypeParams,
        deliveryTypeMstParams: deliveryTypeMstParams,
        serviceAttributeParams: serviceAttributeParams
      })
        // eslint-disable-next-line
        .then(res => {
          console.log(9)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    searchLocation () {
      this.processing = true

      let parameters = {
        deviceSerial: this.inpDeviceSerial,
        filters: {
          serviceUuid: this.inpService
        }
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['community'],
        ['v1LocationNicknameGet'],
        [parameters])
        .then(res => {
          console.log(res)
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            this.locationNickname = res[0].data.nickName
            if (this.inpLocation !== res[0].data.locationUuid) {
              this.inpLocation = res[0].data.locationUuid
            }

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    clearForm () {
      if (this.isAdmin) {
        this.inpService = ''
      }
      this.inpTarget = ''
      this.inpDeliveryType = ''
      this.inpNoticeType = ''
    },

    confirmData () {
      if (!this.formIsValid) return

      this.setInputValue({
        key: 'inpDeliveryPlanType',
        value: this.noticeType === 'sound_broadcast'
          ? 3 : 1
      })

      // ロケーションのニックネームをstoreに保持
      this.setLocationNickname(this.locationNickname)

      // 入力データをリセット
      this.setInputValue({
        key: 'inpDeliveryContents',
        value: null
      })

      // お知らせの詳細を登録
      this.$router.push({
        name: 'NoticeForm'
      })
    }
  }
}
